/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const RoutingLongUnits = {
  Miles: "miles",
  Kilometers: "kilometers",
} as const;
export type RoutingLongUnits =
  (typeof RoutingLongUnits)[keyof typeof RoutingLongUnits];

export function instanceOfRoutingLongUnits(value: any): boolean {
  for (const key in RoutingLongUnits) {
    if (Object.prototype.hasOwnProperty.call(RoutingLongUnits, key)) {
      if (RoutingLongUnits[key as keyof typeof RoutingLongUnits] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RoutingLongUnitsFromJSON(json: any): RoutingLongUnits {
  return RoutingLongUnitsFromJSONTyped(json, false);
}

export function RoutingLongUnitsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RoutingLongUnits {
  return json as RoutingLongUnits;
}

export function RoutingLongUnitsToJSON(value?: RoutingLongUnits | null): any {
  return value as any;
}

export function RoutingLongUnitsToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): RoutingLongUnits {
  return value as RoutingLongUnits;
}
